<ey-toggle-template
  [selectedValue]="selectedValue"
  [displayCustomLabels]="displayCustomLabels"
  [slim]="slim"
  [isDisabled]="isDisabled"
  [labelOn]="labelOn"
  [labelOff]="labelOff"
  (selectedChanged)="onSelectedChanged($event)"
></ey-toggle-template>
